import React from "react";

export const SuccessIcon = () => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.52501 11.657L0.575012 6.70699L1.98901 5.29299L5.52651 8.82649L5.52501 8.82799L14.01 0.342987L15.424 1.75699L6.93901 10.243L5.52601 11.656L5.52501 11.657Z" fill="white" />
  </svg>
)
